export default [
  {
    path: '/ceo',
    name: 'ceo',
    component: () => import('@/views/ceo/Index.vue'),
    meta: { title: 'app_ceo' }
  },
  {
    path: '/CeoDetail',
    name: 'CeoDetail',
    component: () => import('@/views/ceo/CeoDetail.vue'),
    meta: { title: 'app_msg_detail' }
  }
]
